import { useNotify, useRefresh, required, TextInput, email } from "react-admin";
import EmailIcon from "@mui/icons-material/Email";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { Button } from "@mui/material";

const EditEmailDialog = ({
  request,
  currentEmailProp = null,
  variant = null,
  source = null,
  userRecord,
  hasEditUsersPermission,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const sourcePath = source || "email";
  const currentEmail = currentEmailProp || userRecord?.email;

  const handleSubmit = async data => {
    const newEmail = sourcePath.split(".").reduce((obj, key) => obj?.[key], data);
    await dataProvider.customRequest(request, { newEmail }, "PUT");
    notify("Успешно заявена промяна за имейл", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на имейл"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant={variant || "text"}
          size="small"
          color="primary"
          startIcon={<EmailIcon />}
          disabled={!hasEditUsersPermission}
        >
          Промяна на имейл
        </Button>
      }
    >
      <TextInput
        source={sourcePath}
        validate={[required(), email()]}
        defaultValue={currentEmail}
        label="Имейл адрес"
        fullWidth
      />
    </FormModal>
  );
};

export default EditEmailDialog;
